(ns dashboard.components.command-palletes
  (:require
   [clojure.string :as string]
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [headlessui-reagent.core :as ui]
   [dashboard.i18n :refer [tr]]
   [dashboard.utils :refer [cs listen index-by]]
   [dashboard.components.dialog :refer [dialog]]
   [dashboard.components.button :refer [button]]
   [dashboard.components.select :refer [select]]
   [dashboard.components.profile :refer [user-profile-img display-user-fullname]]
   [dashboard.components.tag :refer [tag]]
   [dashboard.subs :as subs]
   ["@heroicons/react/solid" :refer
    [SearchIcon SelectorIcon ChevronRightIcon FilterIcon]]))

(defn string->query [s]
  (string/replace (string/lower-case s) #"\s+" ""))

(defn- filter-dialog-content [{:keys [state]}]
  (let [title-choices (cons
                       {:name (tr :filter/all-titles)
                        :id "all"}
                       (listen ::subs/titles))
        title-choices-by-id (index-by title-choices :id)
        space-choices (cons
                       {:name (tr :filter/all-spaces)
                        :nameJp (tr :filter/all-spaces)
                        :id "all"}
                       (listen ::subs/active-spaces))
        space-choices-by-id (index-by space-choices :id)]
    [:div.h-96
     [:div
      [select
       {:label (tr :user/title)
        :class "w-64"
        :id-key :id
        :selected (get title-choices-by-id (:title @state))
        :items-list title-choices
        :on-change #(swap! state assoc :title %)}]]
     [:div
      [select
       {:label (tr :user/space)
        :class "w-64"
        :id-key :id
        :name-key (if (= (listen ::subs/locale) :ja)
                    :nameJp
                    :name)
        :selected (get space-choices-by-id (:space @state))
        :items-list space-choices
        :on-change #(swap! state assoc :space %)}]]]))

(defn user-command-palletes
  [{:keys [state on-click people default-filters]
    :or {people (listen ::subs/staffs)
         default-filters {:title "all"
                          :space "all"}}}]
  (reagent/with-let
    [!query (reagent/atom "")
     !filter-dialog-state (reagent/atom {:is-open? false
                                         :title (get default-filters :title "all")
                                         :space (get default-filters :space "all")})
     !filtered-people (reagent/reaction
                       (let [query @!query]
                         (cond->> people
                           (not= (:title @!filter-dialog-state) "all")
                           (filter #(= (:titleId %) (:title @!filter-dialog-state)))

                           (not= (:space @!filter-dialog-state) "all")
                           (filter #(= (:spaceId %) (:space @!filter-dialog-state)))

                           (not (string/blank? query))
                           (filter #(or
                                     (when (some? (:firstName %))
                                       (>= (.indexOf
                                            (.toLowerCase (:firstName %))
                                            (.toLowerCase query))
                                           0))
                                     (when (some? (:lastName %))
                                       (>= (.indexOf
                                            (.toLowerCase (:lastName %))
                                            (.toLowerCase query))
                                           0))
                                     (when (some? (:lastNameJp %))
                                       (>= (.indexOf
                                            (:lastNameJp %)
                                            query)
                                           0))
                                     (when (some? (:firstNameJp %))
                                       (>= (.indexOf
                                            (:firstNameJp %)
                                            query)
                                           0)))))))
     !selected (reagent/atom (first (cond->> people
                                      (not= (:space default-filters) "all")
                                      (filter #(= (:spaceId %) (:space default-filters))))))]
    (let [selected @!selected
          filtered-people @!filtered-people]
      [:<>
       [dialog
        {:state !filter-dialog-state
         :title (tr :action/filter)
         :content [filter-dialog-content
                   {:state !filter-dialog-state}]}]
       [ui/transition
        {:show (:is-open? @state)}
        [ui/dialog
         {:open (:is-open? @state)
          :as "div"
          :class "relative z-40"
          :on-close #(swap! state assoc :is-open? false)}
         [ui/transition-child
          {:enter "ease-out duration-300"
           :enter-from "opacity-0"
           :enter-to "opacity-100"
           :leave "ease-in duration-200"
           :leave-from "opacity-100"
           :leave-to "opacity-0"}
          [ui/dialog-overlay
           {:class "fixed inset-0 bg-gray-500 bg-opacity-25 transition-opacity"}]]

         [:div.fixed.z-10.inset-0.overflow-y-auto.p-4.sm:p-6.md:p-20
          [ui/transition-child
           {:enter "ease-out duration-300"
            :enter-from "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            :enter-to "opacity-100 translate-y-0 sm:scale-100"
            :leave "ease-in duration-200"
            :leave-from "opacity-100 translate-y-0 sm:scale-100"
            :leave-to "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"}
           [ui/dialog-panel
            {:class "mx-auto max-w-3xl transform divide-y divide-gray-100 overflow-hidden rounded-xl bg-white shadow-2xl ring-1 ring-black ring-opacity-5 transition-all"}
            [ui/combobox
             {:value (:id selected)
              :on-change #(reset! !selected (get (listen ::subs/staffs-by-id) (str %)))}
             [:<>
              [:div.relative
               [:> SearchIcon
                {:class "pointer-events-none absolute top-3.5 left-4 h-5 w-5 text-gray-400"
                 :aria-hidden true}]
               [ui/combobox-input
                {:class "h-12 w-full border-0 bg-transparent pl-11 pr-4 text-gray-800 placeholder-gray-400 focus:ring-0 sm:text-sm"
                 :placeholder "Search..."
                 :display-value (fn [id]
                                  (if (= (listen ::subs/locale) :ja)
                                    (:lastNameJp (get (listen ::subs/staffs-by-id) id))
                                    (:lastName (get (listen ::subs/staffs-by-id) id))))
                 :on-change #(reset! !query (string->query (.-value (.-target %))))}]
               [button
                {:class "absolute top-2.5 right-4"
                 :small? true
                 :intent :intent/default
                 :on-click #(swap! !filter-dialog-state assoc :is-open? true)}
                [:> FilterIcon
                 {:class (cs "pointer-events-none h-5 w-5"
                             (if (or
                                  (not= (:title @!filter-dialog-state) "all")
                                  (not= (:space @!filter-dialog-state) "all"))
                               "text-primary-500" "text-gray-400"))
                  :aria-hidden true}]]]
              [ui/combobox-options
               {:class "flex divide-x divide-gray-100"
                :static true
                :hold true}
               [:div.max-h-96.min-w-0.flex-auto.scroll-py-4.overflow-y-auto.px-6.py-4.sm:h-96
                [:div.-mx-2.text-sm.text-gray-700x
                 (doall
                  (for [person filtered-people]
                    ^{:key (:id person)}
                    [ui/combobox-option
                     {:value (:id person)
                      :class (fn [{:keys [active]}]
                               (cs "flex cursor-default select-none items-center rounded-md p-2"
                                   (when active "bg-gray-100 text-gray-900")))}
                     (fn [{:keys [active]}]
                       [:<>
                        [user-profile-img
                         {:class "h-8 w-8 text-xs"
                          :user person}]
                        [:div.flex-auto
                         [:span.ml-3.truncate
                          (str (:firstName person) " " (:lastName person))]
                         [:span.ml-2.truncate.text-gray-500
                          (str (:lastNameJp person) " " (:firstNameJp person))]]
                        (when active
                          [:> ChevronRightIcon
                           {:class "ml-3 h-5 w-5 flex-none text-gray-400"
                            :aria-hidden true}])])]))]]

               [:div.hidden.h-96.flex-none.flex-col.divide-y.divide-gray-100.overflow-y-auto.sm:flex
                {:class "w-1/2"}
                [:div.flex-none.p-6.text-center
                 [user-profile-img
                  {:class "h-16 w-16 mx-auto"
                   :user selected}]
                 [:h2.mt-3.font-semibold.text-gray-900
                  (display-user-fullname selected)]
                 [:h3.font-semibold.text-gray-700
                  (:titleId selected)]
                 [:p.text-sm.leading-6.text-gray-500
                  (:title selected)]]
                [:div.flex.flex-auto.flex-col.justify-between.p-6
                 (when (some? (:email selected))
                   [:dt.col-end-1.font-semibold.text-gray-900
                    (tr :user/email)])
                 (when (some? (:email selected))
                   [:dd.truncate
                    [:a.text-primary-600.underline
                     {:href (str "mailto:" (:email selected))}
                     (:email selected)]])
                 (when (some? (:spaceId selected))
                   [:dt.col-end-1.font-semibold.text-gray-900
                    (tr :user/space)])
                 (when (some? (:spaceId selected))
                   [:dd.truncate.text-primary-600
                    (if (= (listen ::subs/locale) :ja)
                      (:nameJp (get (listen ::subs/spaces-by-id) (:spaceId selected)))
                      (:name (get (listen ::subs/spaces-by-id) (:spaceId selected))))])]

                [:div.flex.flex-auto.flex-col.justify-between.p-6
                 (when (some? on-click)
                   [button
                    {:on-click #(do
                                  (on-click (str (:id selected)))
                                  (swap! state assoc :is-open? false))}
                    (tr :action/select)])]]]]]]]]]]])))
